import React from "react";
import { Navigate } from "react-router";
import {
  GetPodborkaByUrlAPI,
  GetProductByServiceUrlAPI,
} from "./api/productsApi";
import ProtectedRoute from "./pages/ProtectedRoute";
import NotFound from "./pages/not_found";
import Podborka from "./pages/podborka";

// lazy imports как есть
const Main = React.lazy(() => import("./pages/mainPage"));
const Payment = React.lazy(() => import("./pages/uslugi/payment_page"));
const Uslugi = React.lazy(() => import("./pages/uslugi"));
const Usluga = React.lazy(() => import("./pages/usluga"));
const Blog = React.lazy(() => import("./pages/blog"));
const Info = React.lazy(() => import("./pages/info"));
const Login = React.lazy(() => import("./pages/account/login"));
const Account = React.lazy(() => import("./pages/account/profile"));
const Order = React.lazy(() => import("./pages/account/order"));

const routes = [
  {
    path: "/",
    element: <Main />,
  },
  {
    path: "/uslugi/",
    element: <Uslugi />,
  },
  {
    path: "/uslugi/:url/",
    element: <Usluga />,
    loader: async ({ params }: { params: { url: string } }) => {
      if (!params.url) throw new Error("URL is required");
      return await GetProductByServiceUrlAPI({ service_url: params.url });
    },
  },
  {
    path: "/uslugi/:url/payment/",
    element: <Payment />,
    loader: async ({ params }: { params: { url: string } }) => {
      if (!params.url) throw new Error("URL is required");
      return await GetProductByServiceUrlAPI({ service_url: params.url });
    },
  },
  {
    path: "/blog/",
    element: <Blog />,
  },
  {
    path: "/blog/:url/",
    element: <Info />,
  },
  {
    path: "/account/",
    element: (
      <ProtectedRoute>
        <Account /></ProtectedRoute>
    ),
  },
  {
    path: "/account/order/:order_id/",
    element: (
      <ProtectedRoute>
        <Order />
      </ProtectedRoute>
    ),
  },
  {
    path: "/account/login/",
    element: <Login />,
  },
  {
    path: "/podborki/",
    element: <NotFound />,
  },
  {
    path: "/podborki/:url/",
    element: <Podborka />,
    loader: async ({ params }: { params: { url: string } }) => {
      if (!params.url) throw new Error("URL is required");
      return await GetPodborkaByUrlAPI({ podborka_url: params.url });
    },
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
